import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/job-description-red-flags/RedFlagContent.tsx");
